import { render, staticRenderFns } from "./appcustomers.vue?vue&type=template&id=349e84ca&scoped=true&"
import script from "./appcustomers.vue?vue&type=script&lang=js&"
export * from "./appcustomers.vue?vue&type=script&lang=js&"
import style0 from "./appcustomers.vue?vue&type=style&index=0&id=349e84ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e84ca",
  null
  
)

export default component.exports